import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { QuickQuotes } from './components/QuickQuotes';
import { PainSection } from './components/PainSection';
import { SystemIntro } from './components/SystemIntro';
import { Volumes } from './components/Volumes';
import { ContentCarousel } from './components/ContentCarousel';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { WhatsappProof } from './components/WhatsappProof';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Comparison } from './components/Comparison';
import { FinalCta } from './components/FinalCta';
import { ClosingWords } from './components/ClosingWords';
import { Footer } from './components/Footer';
import { WhatsappButton } from './components/WhatsappButton';
export function App() {
  return <div className="min-h-full w-full bg-paper text-ink" data-id="element-0" data-mp="3iiwfgpji5k3r">
      <UrgencyBar data-id="element-1" data-mp="3mlj82snzz920" />
      <main data-id="element-2" data-mp="3ml12h5fg3ihf">
        <Hero data-id="element-3" data-mp="3mkhlbqxmcy4g" />
        <StatsBar data-id="element-4" data-mp="3mk83iqmq9x9u" />
        <QuickQuotes data-id="element-5" data-mp="3mjpyp5m02aqb" />
        <PainSection data-id="element-6" data-mp="3rc9e8848zfxr" />
        <SystemIntro data-id="element-7" data-mp="3rbrc4uuwm7hx" />
        <Volumes data-id="element-8" data-mp="3rdkhm6ts6loc" />
        <ContentCarousel data-id="element-9" data-mp="3rd1azm9kzjpm" />
        <Bonuses data-id="element-10" data-mp="3relwkmdx3sbc" />
        <Offer data-id="element-11" data-mp="5opww5kum4f" />
        <Testimonials data-id="element-12" data-mp="680frswe88f" />
        <WhatsappProof data-id="element-13" data-mp="5gfrc0u9uwx" />
        <Guarantee data-id="element-14" data-mp="82ovg3doih9" />
        <Faq data-id="element-15" data-mp="2zld1d7i6tbah" />
        <Comparison data-id="element-16" data-mp="2zllcouynw8jk" />
        <FinalCta data-id="element-17" data-mp="2zm4vedw4z0yn" />
        <ClosingWords data-id="element-18" data-mp="2zmwif0bo3qdb" />
      </main>
      <Footer data-id="element-19" data-mp="33mowfsjtyoq2" />
      <WhatsappButton data-id="element-20" data-mp="33m5cy7ej7s9x" />
    </div>;
}